import styled from 'styled-components';

import { gridSizes, media, weights } from 'utils/style';

import Addresses from 'components/RecurringOrderSuggestionsModal/Sections/Addresses/component';

export default styled(Addresses)`
  & {
    margin-top: ${gridSizes('M')};
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    display: flex;
    justify-content: flex-start;
    &:last-child {
      .next-step {
        background-color: var(--white);
      }
    }
  }

  .step-data-wrapper {
    line-height: 1.2;
    flex-grow: 1;
    position: relative;
    padding: 0 0 ${gridSizes('M')} 0;
    max-width: 90%;

    ${media.lessThan('small')`
      font-size: 14px;
      padding: ${gridSizes('L')} 0;
      line-height: 1.4;
    `}

    ${media.lessThan('extraSmall')`
      padding: 20px 0;
    `}
  }

  .step-progress {
    max-width: ${gridSizes('L')};
    width: 100%;
    margin: 0 ${gridSizes('M')} 0 0;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .current-step {
    box-sizing: content-box;
    height: ${gridSizes('L')};
    width: ${gridSizes('L')};
    background-color: var(--grey-mouse)};
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .state {
    box-sizing: content-box;
    height: ${gridSizes('M')};
    width: ${gridSizes('M')};
    background-color: var(--grey-mouse)};
    border-radius: 50%;
    border: 2px solid var(--white)};
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .next-step {
    flex-grow: 1;
    width: 2px;
    background-color: var(--grey-mouse)};
    border-top: solid 3px #fff;
  }

  .companyName {
    color: var(--grey800')};
    font-size: 16px;
    line-height: 21px;
    font-weight: ${weights('medium')};
  }

  .addressLine {
    margin-top: ${gridSizes('S')};
    color: var(--grey700)};
    font-size: 14px;
    line-height: 20px;
    font-weight: ${weights('normal')};
  }

  hr {
    border-bottom: 1px solid var(--grey300)};
    margin: 0 40px;
    border-top: none;
  }
`;
